export default __webpack_public_path__ + "static/media/R3.1aa81eba.png";